module.exports = __webpack_public_path__ + "static/media/CC2-0.22847eff.jpg";